import FirstView from './FirstView';

class PageBrand {
  constructor(mainApp) {
    console.log('PageBrand');
    this.mainApp = mainApp;
    this.firstView = new FirstView();
  }
  onLoadWindow() {
    this.firstView.show();
  }
  onWindowResize() {
    this.firstView.resize();
  }
  onWindowScroll() {}
  destroy() {}
}

export default PageBrand;
